export const drawWidth = 3000
export const drawHeight = Math.round((drawWidth / 21) * 9)

export const boxHeight = 250
export const boxWidth = drawWidth * 0.25
export const boxMargin = 30

export const chartHeight = drawHeight * 0.9
export const chartWidth = drawWidth * 0.75
export const chartWindowBegins = chartHeight * 0.25
export const chartWindowEnds = chartHeight * 0.9
